export default "__VITE_ASSET__CsI$YWLg__"